import { render, staticRenderFns } from "./ModalNorm.vue?vue&type=template&id=96e953de&scoped=true"
import script from "./ModalNorm.vue?vue&type=script&lang=js"
export * from "./ModalNorm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e953de",
  null
  
)

export default component.exports